<template>
  <div>
    <div class="mb-4">
      <div class="font-14">你还未参加任何课程，报名体验下吧~</div>
    </div>
    <div>
      <a-spin :spinning="loading">
        <open-course :spinning="spinning" @current-change="getCurrent" :data="tableData"></open-course>
      </a-spin>
    </div>
  </div>
</template>

<script>
import openCourse from '@/views/LearningCenter/components/openCourse.vue'
import { getOpenSchedulePage } from '@/api/myClass'
export default {
  props: {

  },
  data() {
    return {
      tableData: {
        records: [],
        total: 0
      },
      loading: true,
      spinning: false
    }
  },
  components: {
    openCourse
  },
  computed: {

  },
  created() {
    this.getData()
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    getData() {
      const params = {
        current: this.current,
        size: 8
      }
      getOpenSchedulePage(params).then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },
    getCurrent(e) {
      this.current = e
      this.getData()
    }
  }
}
</script>

<style scoped lang="less">
.text-color {
  color: #5e668d;
}
</style>
